export const ENTRADA = '0ce98025-7ec2-4650-9089-8087f45e0b47';

export const SALIDA = '1e20f862-a6da-4077-8fea-522e78b9a97e';

export const AJUSTE = '6bd3ba59-7b75-4e9b-958d-286ca54e7b37';
